import { cloneDeep } from 'lodash';
import * as types from './mutation-types';
import default_state from './state';

import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import InstituicaoPresenter from '@Presenter/instituicao-presenter';

const findIndex = (arr, id) => arr.findIndex(obj => obj.id === id);

const getGoogleMap = () => {
  try {
    InstituicaoPresenter.googleMapsProxy()
      .then(response => {
        const VUE_APP_GOOGLE_MAPS_KEY = response.apiKey;
        if (VUE_APP_GOOGLE_MAPS_KEY)
          Vue.use(VueGoogleMaps, {
            load: {
              key: VUE_APP_GOOGLE_MAPS_KEY,
              libraries: 'places'
            }
          });
      });
  } catch (error) {
    console.log('Context error: ', error);
  }
};

export default {
  [types.CONTEXTO](state, contexto) {
    state.contexto = contexto;
    if ((contexto || {}).instituicao) {
      getGoogleMap();
    }
  },

  [types.LOCALIZACAO](state, localizacao) {
    state.localizacao = localizacao;
  },

  [types.SET_FILTRO_VENDA](state, filtro_venda) {
    state.filtro_venda = filtro_venda;
  },

  [types.SET_FILTRO_COMPRA](state, filtro_compra) {
    state.filtro_compra = filtro_compra;
  },

  [types.SET_FILTRO_LOTE](state, filtro_lote) {
    state.filtro_lote = filtro_lote;
  },

  [types.AVATAR_BASE64](state, base_64) {
    state.contexto.instituicao.avatar_base64 = base_64;
  },

  [types.SNACKBAR](state, config) {
    state.snackbar = {
      visible: true,
      message: '',
      color: 'success',
      timeout: 3000,
      ...config
    };
  },

  [types.CLEAR_STATE](state) {
    const _state = cloneDeep(default_state);
    Object.keys(state).forEach(key => {
      state[key] = cloneDeep(_state[key]);
    });
  },

  [types.UNSET_ITEMS](state) {
    state.items = [];
  },

  [types.SET_ITEMS](state, items) {
    state.items = items;
  },

  [types.ITEMS_ADD](state, { items, item }) {
    const i = findIndex(items, item.id);
    items.splice(i !== -1 ? i : 0, i !== -1 ? 1 : 0, Object.assign((items[i] || {}), item));
  },

  [types.ITEMS_DEL](state, { items, item }) {
    const i = findIndex(items, item.id);
    items.splice(i, 1);
  },

  [types.SET_TIPO_AGENDA](state, tipo) {
    state.tipo_agenda = tipo;
  },

  [types.NOTIFICATION](state, config) {
    state.notification = {
      visible: true,
      title: '',
      message: '',
      color: '#1976D2',
      ...config
    };
  }
};
